<div class="footer">
    <span class="version-text">{{copyright}} {{version}} | {{envName}}</span>
</div>